<template>
	<div class="app-header" id="app-header" >
		<div class="row alert alert-primary" align="center" v-if="user.uid && !user.emailVerified">
			<div class="col-12" @click="btnVerifyEmailClick">
                Please verify your email address using the link in the email we sent you after you created your account (you may have to check your SPAM folder for the verification email). <button class="btn btn-link">Click here to resend verification email.</button>
            </div>
        </div>
        <div class="row col-12">
			<div class="col-7 col-md-5">
                <h4>
                <img src="../assets/rotary_rotaract_logo.png" class="img-fluid app-logo mr-2 pointer" @click="$router.push('/')"/>

                    <!-- {{pageTitle}}
                    <img src="https://district-conference-7030.web.app/rotary_logo.png" class="img-fluid app-logo mr-2"/> -->
                </h4>
            </div>
            <div class="col-12 col-md-7 app-header-menu">
                <a v-if="userProfile.admin" class="btn btn-lg text-primary" :href="`/admin/${userProfile.admin}`">
                    <i class="fas fa-chart-pie"></i>
                    <small style="font-size:10px; display:block;">Admin</small>
                </a>
                <button class="btn btn-lg text-primary" @click="$router.push('/')">
                    <i class="fas fa-stream"></i>
                    <small>Events</small>
                </button>
                <button class="btn btn-lg text-primary" @click="$router.push('/registrations')">
                    <i class="far fa-calendar"></i>
                    <small>Registrations</small>
                </button>
                <!-- <button class="btn btn-lg text-primary" @click="$router.push('/')">
                    <i class="fas fa-calendar-alt"></i>
                    <small>Agenda</small>
                </button>
                <button class="btn btn-lg text-primary" @click="$router.push('/')">
                    <i class="fas fa-info-circle"></i>
                    <small>Info</small>
                </button> -->
                <button class="btn btn-lg text-primary" @click="$router.push('/profile')">
                    <i class="fas fa-user"></i>
                    <small>Profile</small>
                </button>
            </div>
		</div>
	</div>  
</template>

<script>
    const fb = require("../firebaseConfig")
	export default {
		name: "AppHeader",
		filters: {
		},
		components: {
			
		},
		computed:{
			pageTitle(){
                return this.$store.state.pageTitle
            },
            showHeader(){ 
                return true
            },
            user(){
                return this.$store.state.loggedInUser
            },
            userProfile(){
                console.log(this.$store.state.userProfileDoc)
                return this.$store.state.userProfile
            },
            msgCount(){
                let messages = this.$store.state.messages
                const filter = (msg)=>{
                    return !msg.data.read.includes(this.userProfile.uuid)
                }
                return messages.filter(filter)
            },
		},
		data(){
			return{
				isBusy: false,
			}
		},
		methods:{

            btnVerifyEmailClick(){
                fb.firebase.auth().currentUser.sendEmailVerification().then(()=> {
                    this.$toast.success("Verification email sent!", {position:"top"})
                }).catch(function(error) {
                    this.$toast.error("Unable to send verification email!", {position:"top"})
                    console.log(error)
                })
            }
			
		},
		mounted(){
            if(fb.firebase.messaging.isSupported()){
                fb.messaging.onMessage((payload) => {
                    if(this.pageTitle !== "Chats") this.$toast.info(`${payload.notification.title}`, {position:"top"})
                })
            }
        }
	}
</script>
